<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="single-line jiaotongsheshifenbu">
        <div class="chart-title">交通设施分布</div>
        <div class="chart-content">
          <div class="left">
            <ul class="jiaotongsheshiList" v-if="JiaotongSheshiFenbuData">
              <li
                :key="index"
                v-for="(item, index) in JiaotongSheshiFenbuData.pointData"
              >
                <img :src="item.icon" />
                {{ item.item }}数量
                <span :style="{ color: JiaotongSheshiFenbuColorList[index] }">{{
                  item.data.length
                }}</span>
              </li>
            </ul>
          </div>
          <div class="right">
            <JiaoTongSheshiFenbu
              :colorList="JiaotongSheshiFenbuColorList"
              :mapData="JiaotongSheshiFenbuData"
              v-if="JiaotongSheshiFenbuData"
            />
          </div>
        </div>
      </div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import JiaoTongSheshiFenbu from "@/components/ZiyuanPinggu/JiaotongTongdaFenxiDatail/JiaoTongSheshiFenbu.vue";

export default {
  name: "JiaotongTongdaFenxiDatail",
  components: {
    ChildModal,
    JiaoTongSheshiFenbu
  },
  props: {},
  data() {
    return {
      JiaotongSheshiFenbuColorList: [
        "#ba2828",
        "#00cdff",
        "#a1e058",
        "#1e89ff",
        "#ffe05f"
      ],
      JiaotongSheshiFenbuData: null
    };
  },
  mounted() {
    // 请求交通设施分布
    fetch(
      "/data/ZiyuanPinggu/JiaotongTongdaFenxiDetail/JiaotongSheshiFenbu.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JiaotongSheshiFenbuData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.jiaotongsheshifenbu {
  .chart-content {
    width: 96%;
    height: 520px;
    .left {
      width: 18%;
      height: 100%;
      float: left;
      .jiaotongsheshiList {
        width: 100%;
        > li {
          font-size: 0.2rem;
          height: 0.6rem;
          margin: 0.4rem 0;
          img {
            width: 0.7rem;
            height: 0.3rem;
            display: block;
            margin: 0 auto 0.1rem;
          }
          > span {
            margin-left: 0.2rem;
            font-weight: bold;
          }
        }
      }
    }
    .right {
      width: 82%;
      height: 100%;
      float: right;
    }
  }
}
</style>
